<template>
  <div
    class="tw:flex tw:content-center tw:border tw:border-default-200 tw:rounded-xs tw:bg-default-000 tw:min-h-[7.5rem] tw:min-w-[7.5rem] tw:max-h-[7.5rem] tw:max-w-[7.5rem]"
  >
    <EdroneSkeletonLoader v-if="isLoading" class="tw:h-[7.5rem] tw:w-[7.5rem]" />

    <template v-else>
      <img v-if="img" :src="img" class="tw:w-full tw:p-0.5 tw:object-contain" />

      <div v-else class="tw:flex tw:items-center tw:justify-center tw:min-h-[7.5rem] tw:min-w-[7.5rem]">
        <FontAwesomeIcon icon="fa-light fa-image-slash" />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EdroneSkeletonLoader from "edrone-components/EdroneSkeletonLoader.vue";

interface Props {
  img: string | null;
  isLoading: boolean;
}

defineProps<Props>();
</script>
